// extracted by mini-css-extract-plugin
module.exports = {"table":"BorrowerApplications_table__3XyNW","noItems":"BorrowerApplications_noItems__2LX_8","title":"BorrowerApplications_title__1I6XY"};